import { BelongsToField } from "../models/BelongsToField";

export class ConfigurableFieldOption{
    id:string;
    value:string;
    parentCode:string=null;

    
  }